import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from './services/auth.service';
import { SalesService } from './services/sales.service';

@Injectable({
  providedIn: 'root',
})
export class SaleCompanyRoleGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router, private readonly saleService: SalesService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.authService.IsSalesCompany()) {
      return true;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }
}
